const scrollToTopScreen = () => {
  window.scrollTo({ top: 0, behavior: 'smooth' });
};

export default scrollToTopScreen;
